import React, { useState, useEffect } from 'react';
import { PacmanLoader } from 'react-spinners';
import { useHistory } from 'react-router-dom';
import { CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppInfoservice from '../../../../service/common/Appinfo';
import { Modal, Button } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: 'lightgrey',
    color: 'white',
  },
  spinner: {
    marginBottom: theme.spacing(2),
  },
}));

const Register = () => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [url,serUrl]=useState('')
  useEffect(() => {
    const appInfoservice = new AppInfoservice();
    appInfoservice.getStoreUrl('register')
      .then((response) => {
          setLoading(true);
          serUrl(response.data.url)
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

const VisitUrl=(url)=>{
 window.location.href = url;
 localStorage.clear();
}

  return (
    <div className={classes.root}>
      {loading ? (
      <>
        <Modal centered={true} show={true}>
        <Modal.Header closeButton onClick={()=>{history.goBack()}}>
        </Modal.Header>
        <Modal.Body style={{color:"white"}}>
        <Typography variant="h6" align="center">
            <b>YOU WILL LEAVE THIS PAGE AND WILL BE REDIRECTED TO THE REGISTRATION PAGE</b>
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={()=>{history.goBack()}}>
            CLOSE
          </Button>
          <Button variant="primary" onClick={()=>{VisitUrl(url)}}>
            CONTINUE
          </Button>
        </Modal.Footer>
      </Modal>
        </>
      ) : (
        'Please wait...'
      )}
    </div>
  );
};

export default Register;
